import * as XLSX from "xlsx";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat"

/**
 * @description This function is used to read the excel file and return all the worksheets in json format, this function uses the xlsx library to read the excel file. The column no and row no will also be included in the json object.
 * @param file - The excel file to be read
 * @param firstRow - The header of the excel file
 * @returns - The json object of all the worksheets in the excel file
 */
export const getJSONFromExcel = (
    file: File,
    firstRow: number
): Promise<{
    data: {
        [sheet: string]: { [column: string]: string | null }[];
    };
    columnNumberMapping: {
        [sheet: string]: { [column: string]: string };
    };
}> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            if (!e.target || !e.target.result) {
                reject("No data found in the file");
                return;
            }
            const data = e.target.result;
            const workbook = XLSX.read(data, { type: "array" });
            const sheets: {
                [sheet: string]: { [column: string]: string | null }[];
            } = {};
            workbook.SheetNames.forEach((sheetName) => {
                const sheet = workbook.Sheets[sheetName];
                sheets[sheetName] = XLSX.utils.sheet_to_json(sheet, {
                    header: "A",
                    raw: true,
                    defval: null,
                    blankrows: true,
                });
            });

            const newSheets: {
                [sheet: string]: { [column: string]: string | null }[];
            } = {};
            const header: {
                [sheet: string]: { [column: string]: string };
            } = {};
            for (let i = 0; i < Object.keys(sheets).length; i++) {
                const sheet = sheets[Object.keys(sheets)[i]];
                let headers: string[] = [];
                let headersKeys: string[] = [];

                for (let i = 0; i < Object.keys(sheet[firstRow]).length; i++) {
                    let key = sheet[firstRow][Object.keys(sheet[firstRow])[i]];
                    if (key) {
                        headers.push(key);
                        headersKeys.push(
                            Object.keys(sheet[firstRow])[i].toString()
                        );
                    }
                }

                let newSheet: { [key: string]: string | null }[] = [];
                for (let i = firstRow + 1; i < sheet.length; i++) {
                    let row = sheet[i];
                    let newRow: { [key: string]: string | null } = {};
                    let rowFilledFlag = false;
                    for (let j = 0; j < headers.length; j++) {
                        newRow[headers[j]] = row[headersKeys[j]];
                        newRow["column"] = headersKeys[j];
                        if (newRow[headers[j]]) {
                            rowFilledFlag = true;
                        }
                    }
                    newRow["row"] = (i + 1).toString();
                    if (rowFilledFlag) {
                        newSheet.push(newRow);
                    }
                    // newSheet.push(newRow);
                }
                newSheets[Object.keys(sheets)[i]] = newSheet;
            }
            debugger;
            resolve({
                data: newSheets,
                columnNumberMapping: header,
            });
        };
        reader.onerror = (e) => {
            reject(e);
        };
        reader.readAsArrayBuffer(file);
    });
};


export const getFormattedXLSXData = (data: string) => {
    let testWb = XLSX.read(data, { type: "binary", cellNF: true, cellDates: true });
    let testWs = testWb.Sheets[testWb.SheetNames[0]];
    let range = XLSX.utils.decode_range(testWs["!ref"] || "");
    let formattedData = [];
    let headers:{[key:number]: string} = {};
    for (let C = range.s.c; C <= range.e.c; ++C) {
        let cell = testWs[XLSX.utils.encode_cell({ c: C, r: range.s.r })];
        let hdr = "UNKNOWN " + C;
        if (cell && cell.w) hdr = cell.w;
        headers[C] = hdr;
    }
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
        let formattedRow:{[key:string]: string} = {}
        let isEmptyRow = true;
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ c: C, r: R });
            const cell = testWs[cellAddress];
            if (cell && cell.w) {
                isEmptyRow = false;
                if(typeof cell.v === "object"  && cell.z === "m/d/yy"){
                    let dateObject = dayjs(cell.w)
                    formattedRow[headers[C]] = dateObject.format("DD-MM-YYYY")
                }
                else{
                    formattedRow[headers[C]] = cell.w;
                }
            } else if (cell && cell.v) {
                isEmptyRow = false;
                formattedRow[headers[C]] = cell.v ;
            } else {
                formattedRow[headers[C]] = "";
            }
            
        }
        if(!isEmptyRow){
            formattedData.push(formattedRow);
        }
    }
    return formattedData;
}